export default __webpack_public_path__ + "static/343-c5950c794a5927d765cbf28afc63719d.gif";